export enum VisitorType {
    VISITOR = 'VISITOR', VISITORGROUP = 'VISITORGROUP'
}


export class VisitIdentity {
    visitorType: VisitorType;
    customFilterId: number;
    query: string;
}

export enum PersonalVisitStatus {
    IN_PROCESS = 'IN_PROCESS',
    PLANNED = 'PLANNED',
    FINISHED = 'FINISHED',
    NOT_ARRIVED = 'NOT_ARRIVED'
}

export enum InstructionsStatus {
  SUCCESSFUL = 'SUCCESSFUL',
  UNSUCCESSFUL = 'UNSUCCESSFUL',
  NOT_DONE = 'NOT_DONE'
}

export class VisitOverviewResponse {

  totalCount: number;
  visits = new Array<PersonalVisit>();

  constructor(data: any) {
    this.totalCount = data.totalCount;
    const visits = new Array<PersonalVisit>();
    for (const visit of data.visits) {
      visits.push(visit);
    }
    this.visits = visits;
  }
}

export class PersonalVisit {
    yardKey: string;
    id: number;
    name: string;
    firstname: string;
    company: string;
    visitorType: VisitorType;
    numberPlate: string;
    start: string;
    startSortValue: number;
    visitEnd: string;
    rowStyle: string;
    hintStyle: string;
    reason: string;
    notes: string;
    inRegularIntervals: boolean;
    registrationCode: string;
    searchText: string;
    visitedPersonString: string;
    visitedPersonName: string;
    visitedPersonDepartment: string;
    plannedArrival: string;
    expectedArrival: string;
    expectedArrivalSortValue: number;
    reservation: boolean;
    personalVisitStatus: PersonalVisitStatus;
    role: string;
    roleId: number;
    roleDictionaryKey: string;
    lastTerminalRegistrationDate: string;
    lastTerminalRegistrationDateSortValue: number;
    lastClientRegistrationDate: string;
    lastClientRegistrationDateSortValue: number;
    invitationSentDate: string;
    invitationSentDateSortValue: number;
    instructionsStatus: InstructionsStatus;
    instructionsValidUntil: string;
    supplementaryEquipments: string;
}
